import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=0b84f0c1&scoped=true"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84f0c1",
  null
  
)

export default component.exports